import React, { Suspense, lazy } from 'react';

const ShipmentUpdatesPage = lazy( () => import( './ShipmentUpdatesPage' ) );

class SafeShipmentUpdatesPage extends React.Component<
    Record<string, never>,
    { hasError: boolean }
>
{
    state = { hasError: false };

    static getDerivedStateFromError(): { hasError: boolean }
    {
        return { hasError: true };
    }

    render()
    {
        if ( this.state.hasError )
        {
            return (
                <div className='shipment-updates-page'>
                    <h1 className='kat-text--heading-1'>Shipment History</h1>
                    <p>Shipment History functionality is temporarily unavailable.</p>
                </div>
            );
        }

        return (
            <Suspense fallback={<p>Loading Shipment History...</p>}>
                <ShipmentUpdatesPage />
            </Suspense>
        );
    }
}

export default SafeShipmentUpdatesPage;
